// ── The In-Person Sessions section of Add Client and Renew ─────────
//
// MOVED OUT OF app.js UNCHANGED (standing rule ③: extract what you touch, and
// MOVE and CHANGE are separate commits). The same window.* names the forms'
// inline handlers in index.html call: the section shows for hybrid and
// in-person clients, and the format toggle picks Session Credits or Sessions
// Per Period.

// ⚠️ ONE SESSIONS SYSTEM (part 7, decision 4): where the account's switch is on (body.sl-on), Session Credits and
// Total Session Credits are gone, so the format is always Sessions Per Period, in the hidden field that is saved as
// well as on screen. It stayed on its default, "credits", and the client was saved as a credits client.
const sessionsSystemOn = () => typeof document !== 'undefined' && !!document.body && document.body.classList.contains('sl-on');

window.updateSessionSection = function(ctx, serviceType) {
  const show = serviceType === 'hybrid' || serviceType === 'in-person';
  const prefix = ctx === 'renew' ? 'renew' : 'add';
  document.getElementById(`${prefix}-sessions-title`)?.classList.toggle('hidden', !show);
  document.getElementById(`${prefix}-sessions-section`)?.classList.toggle('hidden', !show);
  if (show && sessionsSystemOn()) window.setSessionFormat(ctx, 'recurring');
};

window.setSessionFormat = function(ctx, fmt) {
  if (sessionsSystemOn()) fmt = 'recurring';
  const prefix = ctx === 'renew' ? 'renew' : 'add';
  const fmtInput = document.getElementById(`${ctx === 'renew' ? 'renew' : 'f'}-sessionFormat`);
  if (fmtInput) fmtInput.value = fmt;
  // Toggle active button
  document.querySelectorAll(`#${prefix}-sessions-section .session-fmt-btn`).forEach(btn => {
    btn.classList.toggle('active', btn.dataset.fmt === fmt);
  });
  // Show/hide field groups
  document.getElementById(`${prefix}-session-credits-grp`)?.classList.toggle('hidden', fmt !== 'credits');
  document.getElementById(`${prefix}-session-recurring-grp`)?.classList.toggle('hidden', fmt !== 'recurring');
};
